"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.getState = getState;
const dist_1 = require("../../fs/dist");
const dist_2 = require("../../fs/dist");
const derived_1 = require("../../core/dist/derived");
const dates_1 = require("../../core/dist/dates");
const weaveFilters_1 = require("../../core/dist/filters/weaveFilters");
const sorting_1 = require("../../core/dist/filters/sorting");
const planUtils_1 = require("../../core/dist/planUtils");
const req_1 = require("../../core/dist/entities/req");
const reqCoverage_1 = require("../../core/dist/reqCoverage");
const path = __importStar(require("path"));
async function getState(deps, input) {
    const loomRoot = deps.getActiveLoomRoot(deps.workspaceRoot);
    const registry = deps.registry;
    const isMono = registry.isMonoLoom();
    const mode = isMono ? 'mono' : 'multi';
    const loomName = isMono ? '(local)' : (registry.getActiveLoomName() || 'unknown');
    const weavesDir = path.join(loomRoot, 'loom');
    const allWeaves = [];
    const archivedThreads = [];
    const archivedRefDocs = [];
    const globalDocs = [];
    const globalChats = [];
    const index = await deps.buildLinkIndex(loomRoot);
    if (deps.fs.existsSync(weavesDir)) {
        const entries = await deps.fs.readdir(weavesDir);
        for (const entry of entries) {
            const entryPath = path.join(weavesDir, entry);
            const stat = await deps.fs.stat(entryPath);
            // `reports/` is the report-artifact home (loom/reports/), NOT a weave —
            // reports are standalone snapshot artifacts deliberately kept out of
            // LoomState (see loom-ai-analysis storage decision A). Skip it here so a
            // top-level reports dir is never misread as a phantom weave.
            if (stat.isDirectory() && entry !== '.archive' && entry !== 'reports') {
                if (entry === 'chats') {
                    // Global chats directory — load chat docs directly
                    const chatFiles = (await deps.fs.readdir(entryPath)).filter((f) => f.endsWith('.md'));
                    for (const f of chatFiles) {
                        try {
                            const doc = await (0, dist_2.loadDoc)(path.join(entryPath, f));
                            if (doc.type === 'chat')
                                globalChats.push(doc);
                        }
                        catch (e) {
                            // Skip invalid chat docs
                        }
                    }
                }
                else {
                    try {
                        const weave = await deps.loadWeave(loomRoot, entry, index);
                        if (weave) {
                            allWeaves.push(weave);
                        }
                    }
                    catch (e) {
                        // Skip invalid weaves
                    }
                }
            }
            else if (stat.isFile() && entry.endsWith('.md')) {
                try {
                    globalDocs.push(await (0, dist_2.loadDoc)(entryPath));
                }
                catch (e) {
                    // Skip docs with invalid frontmatter
                }
            }
        }
    }
    // Scan loom/.archive/{weave}/{thread}/ for archived threads — the atomic archive
    // unit (a whole thread folder). Archiving is thread-granular; there are no
    // individually-archived docs, so nothing else is scanned here.
    const archiveDir = path.join(weavesDir, '.archive');
    if (deps.fs.existsSync(archiveDir)) {
        const archWeaves = await deps.fs.readdir(archiveDir).catch(() => []);
        for (const w of archWeaves) {
            const wPath = path.join(archiveDir, w);
            const wStat = await deps.fs.stat(wPath).catch(() => null);
            if (!wStat?.isDirectory())
                continue;
            // loom/refs is the one non-thread area — archived references (and refs chats)
            // are individual docs, collected below rather than as threads.
            if (w === 'refs') {
                const collectMd = async (dir) => {
                    for (const e of await deps.fs.readdir(dir).catch(() => [])) {
                        const p = path.join(dir, e);
                        const s = await deps.fs.stat(p).catch(() => null);
                        if (s?.isDirectory())
                            await collectMd(p);
                        else if (s?.isFile() && e.endsWith('.md')) {
                            try {
                                archivedRefDocs.push(await (0, dist_2.loadDoc)(p));
                            }
                            catch { /* skip */ }
                        }
                    }
                };
                await collectMd(wPath);
                continue;
            }
            const threadDirs = await deps.fs.readdir(wPath).catch(() => []);
            for (const t of threadDirs) {
                const tPath = path.join(wPath, t);
                const tStat = await deps.fs.stat(tPath).catch(() => null);
                if (!tStat?.isDirectory())
                    continue;
                try {
                    archivedThreads.push(await (0, dist_1.loadThread)(loomRoot, w, t, index, tPath));
                }
                catch (e) {
                    // Skip invalid archived thread
                }
            }
        }
    }
    let filteredWeaves = allWeaves;
    if (input?.weaveFilter) {
        const { status, phase, idPattern } = input.weaveFilter;
        if (status && status.length > 0) {
            filteredWeaves = (0, weaveFilters_1.filterWeavesByStatus)(filteredWeaves, status);
        }
        if (phase && phase.length > 0) {
            filteredWeaves = (0, weaveFilters_1.filterWeavesByPhase)(filteredWeaves, phase);
        }
        if (idPattern) {
            filteredWeaves = (0, weaveFilters_1.filterWeavesById)(filteredWeaves, idPattern);
        }
    }
    if (input?.sortBy === 'id') {
        filteredWeaves = (0, sorting_1.sortWeavesById)(filteredWeaves, input.sortOrder !== 'desc');
    }
    const totalWeaves = filteredWeaves.length;
    const activeWeaves = filteredWeaves.filter(w => (0, derived_1.getWeaveStatus)(w) === 'ACTIVE').length;
    const implementingWeaves = filteredWeaves.filter(w => (0, derived_1.getWeaveStatus)(w) === 'IMPLEMENTING').length;
    const doneWeaves = filteredWeaves.filter(w => (0, derived_1.getWeaveStatus)(w) === 'DONE').length;
    const totalPlans = filteredWeaves.reduce((sum, w) => sum + w.threads.reduce((s, t) => s + t.plans.length, 0), 0);
    // Canonical staleness — ONE predicate (core `staleEntries`) feeds both the
    // summary counts here AND the per-thread set the VS Code tree reads, so the
    // extension never recomputes staleness locally and can't drift from `loom stale`.
    let stalePlans = 0;
    const staleIdeas = 0; // ideas are the root of the chain — never stale
    let staleDesigns = 0;
    for (const weave of filteredWeaves) {
        const entries = (0, derived_1.staleEntries)(weave);
        for (const thread of weave.threads) {
            thread.stale = entries.filter(e => e.threadSlug === thread.id && e.actionable);
        }
        const stalePlanIds = new Set();
        for (const e of entries) {
            if (!e.actionable)
                continue;
            if (e.reason === 'plan_design_stale' || e.reason === 'plan_req_stale')
                stalePlanIds.add(e.docId);
            else if (e.reason === 'design_stale')
                staleDesigns++;
        }
        stalePlans += stalePlanIds.size;
    }
    let blockedSteps = 0;
    for (const weave of filteredWeaves) {
        for (const thread of weave.threads) {
            for (const plan of thread.plans) {
                if (!plan.steps)
                    continue;
                for (const step of plan.steps) {
                    if (plan.status === 'implementing' && step.status !== 'done' && step.status !== 'cancelled' && (0, planUtils_1.isStepBlocked)(step, plan, index)) {
                        blockedSteps++;
                    }
                }
            }
        }
    }
    // req scope-coverage gaps: for each thread with a locked req and plans, check
    // the thread's combined plan steps against the req (uncovered Included, steps
    // citing an Excluded id, dangling citations).
    let reqCoverageGaps = 0;
    for (const weave of filteredWeaves) {
        for (const thread of weave.threads) {
            if (thread.req?.status !== 'locked' || thread.plans.length === 0)
                continue;
            const parsed = (0, req_1.parseReq)(thread.req.content ?? '');
            const steps = thread.plans.flatMap(p => p.steps ?? []);
            const cov = (0, reqCoverage_1.checkReqCoverage)(parsed, steps);
            // Attach the per-thread result so the tree can badge it without recomputing,
            // and fold its problems into the aggregate summary count (single pass).
            thread.reqCoverage = cov;
            reqCoverageGaps += cov.uncovered.length + cov.excludedViolations.length + cov.unknownCitations.length;
        }
    }
    return {
        loomRoot,
        mode,
        loomName,
        globalDocs,
        globalChats,
        weaves: filteredWeaves,
        archivedThreads,
        archivedRefDocs,
        index,
        generatedAt: (0, dates_1.nowIso)(),
        summary: {
            totalWeaves,
            activeWeaves,
            implementingWeaves,
            doneWeaves,
            totalPlans,
            stalePlans,
            staleIdeas,
            staleDesigns,
            blockedSteps,
            reqCoverageGaps,
        },
    };
}
